var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('cell',{attrs:{"data":_vm.data.MinTerm,"isChecked":_vm.data.IsChecked},on:{"update":_vm.updateFromCell}})}
var staticRenderFns = []

export { render, staticRenderFns }